import {Component, Input, OnInit} from '@angular/core';
import {Control, ControlAction} from "../../../model/broadcast/control";
import {NgClass, NgIf} from "@angular/common";
import {Broadcast} from "../../../model/broadcast/broadcast";
import {League} from "../../../model/league";

@Component({
  selector: 'app-partner-logos',
  templateUrl: './partner-logos.component.html',
  styleUrls: ['./partner-logos.component.scss'],
  imports: [
    NgIf
  ],
  standalone: true
})
export class PartnerLogosComponent implements OnInit {

  @Input() control: Control;
  @Input() league: League;

  constructor() { }

  ngOnInit(): void {
  }

}
